import * as Yup from "yup";

export const TypeBindSchema = Yup.object().shape({
    type_id: Yup.number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .required("Пожалуйста, укажите значение"),
    type_name: Yup.string().required("Пожалуйста, укажите название"),
});
